const sortSelectorButtons = document.querySelectorAll('.sort-by-button');

for (const sortSelectorButton of sortSelectorButtons) {
  sortSelectorButton?.addEventListener('change', function (e) {
    document.querySelector('#sort-value').value = e.target.value;

    const filterAndSort = document.querySelector('#FilteringAndSorting');
    var event = new Event('input', {
      bubbles: true,
      cancelable: true,
    });
    filterAndSort.dispatchEvent(event);
  });
}
